import { Event, NavigationEnd, Params } from "@angular/router";
import { distinctUntilChanged, filter, map, Observable, OperatorFunction, withLatestFrom } from "rxjs";

function normalizePathWithParams(path: string, params: Params): string {
  const sortedKeys = Object.keys(params).sort((a, b) => String(params[b]).length - String(params[a]).length);

  let normalizedPath = path;

  for (const key of sortedKeys) {
    const value = params[key] as string | undefined;
    if (value) normalizedPath = normalizedPath.replace(value, `:${key}`);
  }

  return normalizedPath;
}

/**
 * Emits the normalised path (`/:programId/...`) of each navigation that changes the path. Query-only navigations
 * (dashboard filters, Home tabs) emit nothing, and the query string and hash are dropped.
 */
export function toPageviewPaths(params$: Observable<Params>): OperatorFunction<Event, string> {
  return events$ =>
    events$.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      withLatestFrom(params$),
      map(([event, params]) => ({ path: event.urlAfterRedirects.split(/[?#]/)[0], params })),
      distinctUntilChanged((previous, current) => previous.path === current.path),
      map(({ path, params }) => normalizePathWithParams(path, params)),
    );
}
